import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";
import { ApiCommonParams } from "../../@types/apiTypes";
import { commonApiParamsToApiParams } from "../../helpers/paramsHelpers";

export function indexNotifications(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/supervisors/notifications`, { params });
}
export function setNotificationViewed(
  ids: (string | number)[]
): Promise<ApiResponse> {
  return Axios.post(`v1/supervisors/notifications/set_as_seen`, {
    notification_ids: ids,
  });
}
export function setNotificationViewedStudent(
  ids: (string | number)[]
): Promise<ApiResponse> {
  return Axios.post(`v1/students/notifications/set_as_seen`, {
    notification_ids: ids,
  });
}
export function setNotificationViewedTutor(
  ids: (string | number)[]
): Promise<ApiResponse> {
  return Axios.post(`v1/tutors/notifications/set_as_seen`, {
    notification_ids: ids,
  });
}
export function indexTutorNotifications(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/tutors/notifications`, { params });
}
export function indexStudentNotifications(
  commonApiParams?: ApiCommonParams
): Promise<ApiResponse> {
  const params = commonApiParamsToApiParams(commonApiParams || {});
  return Axios.get(`v1/students/notifications`, { params });
}
